export enum NavigationPathes {
  HOME = '/',
  WITHDRAWALS = '/withdrawals',
  OFFCHAIN_WITHDRAWALS = '/offchain-withdrawals',
  WITHDRAWALS_STATISTICS = '/withdrawals-statistics',
  CASHBACK_WITHDRAWALS = '/cashback-withdrawals',
  GAMES = '/games',
  USER_ACCOUNTS = '/user-accounts',
  REFERRAL_SEASONS = '/referral-seasons',
  BONUS_TEMPLATES = '/bonus-templates'
}

export const DEFAULT_DATE_FORMAT_STRING = 'dd.MM.yyyy HH:mm:ss'
